const getGridClasses = (count)=>{
    switch(count){
        case 1:
            return "grid-cols-1";
        case 2:
            return "grid-cols-1 md:grid-cols-2";
        case 3:
            return "grid-cols-1 md:grid-cols-2 lg:grid-cols-3";
        case 4:
            return "grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4";
        case 5:
            return "grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-5";
        case 6:
            return "grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-6";
        default:
            return "grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4";
    }
};
const getItemClasses = (index, cols, prefix, count)=>{
    const row = Math.floor(index / cols);
    const col = index % cols;
    const totalRows = Math.ceil(count / cols);
    const isTopRow = 0 === row;
    const isBottomRow = row === totalRows - 1;
    const isLeftCol = 0 === col;
    const isRightCol = col === cols - 1 || index === count - 1;
    const itemBelowIndex = (row + 1) * cols + col;
    const hasItemBelow = itemBelowIndex < count;
    const corners = [];
    const borders = [];
    if (prefix) {
        const resetCorner = "md:" === prefix ? "md:rounded-none" : "lg:" === prefix ? "lg:rounded-none" : "xl:" === prefix ? "xl:rounded-none" : "2xl:rounded-none";
        corners.push(resetCorner);
        const resetBorderR = "md:" === prefix ? "md:border-r" : "lg:" === prefix ? "lg:border-r" : "xl:" === prefix ? "xl:border-r" : "2xl:border-r";
        borders.push(resetBorderR);
        const resetBorderB = "md:" === prefix ? "md:border-b" : "lg:" === prefix ? "lg:border-b" : "xl:" === prefix ? "xl:border-b" : "2xl:border-b";
        borders.push(resetBorderB);
    }
    if (isTopRow && isLeftCol) corners.push(prefix ? "md:" === prefix ? "md:rounded-tl-2xl" : "lg:" === prefix ? "lg:rounded-tl-2xl" : "xl:" === prefix ? "xl:rounded-tl-2xl" : "2xl:rounded-tl-2xl" : "rounded-tl-2xl");
    if (isTopRow && isRightCol) corners.push(prefix ? "md:" === prefix ? "md:rounded-tr-2xl" : "lg:" === prefix ? "lg:rounded-tr-2xl" : "xl:" === prefix ? "xl:rounded-tr-2xl" : "2xl:rounded-tr-2xl" : "rounded-tr-2xl");
    if ((isBottomRow || !hasItemBelow) && isLeftCol) corners.push(prefix ? "md:" === prefix ? "md:rounded-bl-2xl" : "lg:" === prefix ? "lg:rounded-bl-2xl" : "xl:" === prefix ? "xl:rounded-bl-2xl" : "2xl:rounded-bl-2xl" : "rounded-bl-2xl");
    if ((isBottomRow || !hasItemBelow) && isRightCol) corners.push(prefix ? "md:" === prefix ? "md:rounded-br-2xl" : "lg:" === prefix ? "lg:rounded-br-2xl" : "xl:" === prefix ? "xl:rounded-br-2xl" : "2xl:rounded-br-2xl" : "rounded-br-2xl");
    if (!isRightCol && cols > 1) borders.push(prefix ? "md:" === prefix ? "md:border-r-0" : "lg:" === prefix ? "lg:border-r-0" : "xl:" === prefix ? "xl:border-r-0" : "2xl:border-r-0" : "border-r-0");
    if (hasItemBelow) borders.push(prefix ? "md:" === prefix ? "md:border-b-0" : "lg:" === prefix ? "lg:border-b-0" : "xl:" === prefix ? "xl:border-b-0" : "2xl:border-b-0" : "border-b-0");
    return {
        corners: corners.join(" "),
        borders: borders.join(" ")
    };
};
export { getGridClasses, getItemClasses };
